import React, { useCallback, useMemo } from "react";
import { useParams } from "react-router-dom";
import type { FMR1Fields } from "../../../../../api/fmr1";
import { GovernmentScheme, YesNo } from "../../../../../api/fmr1";
import { useAppDispatch, useAppSelector } from "../../../../../app/store";
import { selectFMR1DraftFmrFields, updateFMR1DraftField } from "../../../logic/frm1Slice";
import { FmrSingleRowGridTable } from "../common/FmrSingleRowGridTable";


const PARTICULARS_COL_WIDTH = "253px";
const GOVT_BORROWER_COL1_WIDTH = "443px";
const GOVT_BORROWER_COL2_WIDTH = "270px";
const GOVT_BORROWER_COL3_WIDTH = "281px";

const YES_NO_OPTIONS = Object.values(YesNo).map((v) => ({ name: v, value: v }));
const GOVERNMENT_SCHEME_OPTIONS = Object.values(GovernmentScheme).map((v) => ({ name: v, value: v }));

const GovernmentSchemesTable: React.FC = () => {
  const { id: case_id } = useParams<{ id: string }>();
  const dispatch = useAppDispatch();

  const draftFields = useAppSelector(selectFMR1DraftFmrFields);

  const emptyData = useMemo(() => ({}) as FMR1Fields, []);
  const mergedData = useMemo(() => {
    return { ...emptyData, ...(draftFields as any) } as FMR1Fields;
  }, [draftFields, emptyData]);

  const handleLocalChange = useCallback(
    (key: keyof FMR1Fields, value: any) => {
      if (!case_id) return;
      dispatch(updateFMR1DraftField({ key, value }));
    },
    [case_id, dispatch],
  );

  const involved = mergedData.is_fraud_involved_in_govt_schemes ?? "";

  return (
    <FmrSingleRowGridTable
      title="Details on Government Schemes"
      particularsColWidth={PARTICULARS_COL_WIDTH}
      columns={[
        {
          headerName: "Whether the fraud is involved in any Govt. schemes? Yes/No",
          type: "select",
          options: YES_NO_OPTIONS as any,
          value: involved,
          onChange: (v) => handleLocalChange("is_fraud_involved_in_govt_schemes", v),
          isEditable: true,
          colWidth: GOVT_BORROWER_COL1_WIDTH,
        },
        {
          headerName: "If yes, choose the scheme (Mandatory only if Yes is chosen)",
          type: "select",
          options: GOVERNMENT_SCHEME_OPTIONS as any,
          value: mergedData.chosen_govt_scheme ?? "",
          onChange: (v) => handleLocalChange("chosen_govt_scheme", v),
          isEditable: true,
          colWidth: GOVT_BORROWER_COL2_WIDTH,
        },
        {
          headerName: "Others (Please specify)",
          type: "text",
          value: mergedData.govt_scheme_info_others ?? "",
          onChange: (v) => handleLocalChange("govt_scheme_info_others", v),
          isEditable: true,
          colWidth: GOVT_BORROWER_COL3_WIDTH,
        },
      ]}
    />
  );
};

GovernmentSchemesTable.displayName = "GovernmentSchemesTable";

export default GovernmentSchemesTable;

